import { render, staticRenderFns } from "./SectionWithList.vue?vue&type=template&id=07228fd7&scoped=true&lang=pug&"
import script from "./SectionWithList.vue?vue&type=script&lang=ts&"
export * from "./SectionWithList.vue?vue&type=script&lang=ts&"
import style0 from "./SectionWithList.vue?vue&type=style&index=0&id=07228fd7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07228fd7",
  null
  
)

component.options.__file = "SectionWithList.vue"
export default component.exports